import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import Button from '@atlaskit/button/loading-button';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { useShortcutStrings } from '@confluence/shortcuts/entry-points/ShortcutVisualizer.ts';
import { EDITOR2_SHORTCUTS } from '@confluence/shortcuts/entry-points/confluence-shortcuts.ts';

// oxlint-disable-next-line import/no-cycle
import { WideTooltip } from './PublishButtonWithMoreOptions.tsx';
import { preloadPublishModal } from './preloadPublishModal.ts';
import { i18nShared } from './i18nShared.ts';

const i18n = defineMessages({
	publishButtonTooltip: {
		id: 'publish-modal.default-publish-button-tooltip',
		description:
			'Tooltip for publish button (or split button) to inform user that they can change restrictions and location of the page',
		defaultMessage: 'Select and confirm publish settings',
	},
});

export type Props = {
	saveDraft?: () => void;
	openModalWithAnalytics: (string: any) => () => void;
	savingInProgress: boolean;
	publishButtonDisabled: boolean | undefined;
};

export const DefaultPublishModalButton = ({
	saveDraft,
	openModalWithAnalytics,
	savingInProgress,
	publishButtonDisabled,
}: Props): React.JSX.Element => {
	const publishShortcutStrings = useShortcutStrings({
		shortcut: EDITOR2_SHORTCUTS.PUBLISH,
		isEditorShortcut: true,
	});

	return (
		<Tooltip
			component={WideTooltip}
			content={<FormattedMessage {...i18n.publishButtonTooltip} />}
			shortcut={publishShortcutStrings}
		>
			<Button
				appearance="primary"
				onMouseDown={() => preloadPublishModal(saveDraft)}
				onMouseEnter={() => preloadPublishModal(saveDraft)}
				onFocus={() => preloadPublishModal(saveDraft)}
				onClick={openModalWithAnalytics('PublishModalPublishMoreActionsButton')}
				testId="publish-button"
				isLoading={savingInProgress}
				isDisabled={publishButtonDisabled}
			>
				<FormattedMessage {...i18nShared.publishButton} />
			</Button>
		</Tooltip>
	);
};
